<template>
  <div class="grid place-items-center items-center md:h-screen mt-5 md:mt-0">
    <section class="col-span-12 md:col-span-5 md:w-5/12">
      <div
        class="bg-white shadow-md rounded-xl overflow-hidden lg:m-10"
      >
        <div class="bg-gray-50 p-5">
          <h4>
            {{
              $t("labels.generic", {
                pt: "Redefinir senha",
                en: "Redefine password",
              })
            }}
          </h4>
        </div>
        <form @submit.prevent="submitEmail()">
          <div class="px-5 py-3">
            <div class="flex flex-col my-4">
              <InputText
                id="email-input"
                type="text"
                v-model="form.email"
                :placeholder="
                  $t('labels.generic', {
                    pt: 'Digite o seu e-mail',
                    en: 'Enter your email',
                  })
                "
                :class="v$.form.email.$error ? 'p-invalid' : ''"
              />
              <Errors :errors="v$.form.email.$errors" />
            </div>
            <p class="text-[12px] font-[600]">
              {{ $t("password.label") }}
            </p>
          </div>
          <div
            class="bg-gray-50 p-4 flex justify-end items-center mt-3 border-t border-t-gray-300 rounded-b-lg"
          >
            <Button
              type="button"
              :label="
                $t('labels.generic', {
                  pt: 'Retornar ao login',
                  en: 'Return to login',
                })
              "
              class="btn-simple"
              @click="go.redirectTo('sign-in')"
            />
            <Button
              type="submit"
              :label="$t('labels.generic', { pt: 'Enviar', en: 'Send' })"
              class="btn-primary"
              :disabled="false"
              :loading="loading"
            />
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { email, required } from "@/locale/locale.config";
import { ForgotPassword } from "@/models/auth.model";
import { AuthRest } from "@/services/rest/auth.rest";
import { GoToRoute } from "@/utils/go-to.util";
import { Messages } from "@/utils/messages.util";
import { ToastFactory } from "@/utils/toast-factory.util";
import useVuelidate from "@vuelidate/core";
import { delay } from "rxjs";
import { defineComponent } from "vue";

export default defineComponent({
  name: "forgotPassword",
  computed: {
    rest(): AuthRest {
      return new AuthRest();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
  data() {
    return {
      form: new ForgotPassword(),
      loading: false as boolean,
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      form: {
        email: { email, required },
      },
    };
  },
  methods: {
    submitEmail(): void {
      this.v$.form.$touch();
      if (!this.v$.form.$error) {
        this.loading = true;
        const data = { email: this.form.email };
        this.rest
          .forgotPasswordEmail(data)
          .pipe(delay(500))
          .subscribe({
            next: () => {
              this.loading = false;
              this.go.redirectToPage("sign-in");
              this.$toast.add(ToastFactory.success(Messages.EMAIL_SUCCESS));
            },
            error: () => {
              this.loading = false;
            },
          });
      }
    },
  },
});
</script>
